import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";

const reduceUploadDocumentNotificationState = createStateReducer(initialState, {
  [events.uploadDocumentSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "uploadDocument",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.uploadDocumentFailed]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "uploadDocument",
        flags: ["failure"],
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceUploadDocumentNotificationState };
